import { formatDateToDDMMYYYY, formatMoney } from "../../../../utils/FormatUtils";

export const ColumnThongTinThuoc = [
  {
    name: "STT",
    field: "",
    headerStyle: {
      minWidth: 40,
      maxWidth: 40,
    },
    cellStyle: {
      textAlign: 'center',
    },
    render: (row: any, index: number, stt: number) => stt,
  },
  {
    name: "Mã thuốc/VT",
    field: "",
    headerStyle: {
      minWidth: 150,
      maxWidth: 150,
    },
    render: (row: any, index: number, stt: number) => row.item?.code || row.code,
  },
  {
    name: "Tên thuốc/VT",
    field: "",
    headerStyle: {
      minWidth: 250,
      maxWidth: 250,
    },
    render: (row: any, index: number, stt: number) => row.item?.name || row.itemName,
  },
  {
    name: "Số lượng",
    field: "",
    headerStyle: {
      minWidth: 100,
      maxWidth: 100,
    },
    cellStyle: {
      textAlign: "center",
    },
    render: (row: any, index: number, stt: number) => formatMoney(row.item?.totalQuantity || row.totalQuantity),
  },
  {
    name: "Đơn vị",
    field: "",
    headerStyle: {
      minWidth: 80,
      maxWidth: 80,
    },
    cellStyle: {
      textAlign: "center",
    },
    render: (row: any, index: number, stt: number) => row.item?.unitofMeasureName || row.unitId,
  },
  {
    name: "Liều dùng",
    field: "",
    headerStyle: {
      minWidth: 300,
      maxWidth: 300,
    },

    render: (row: any, index: number, stt: number) => row.usageIns || row.instructions,
  },
   {
    name: "Cách dùng",
    field: "",
    headerStyle: {
      minWidth: 350,
      maxWidth: 350,
    },

    render: (row: any, index: number, stt: number) => row.usageIns || row.instructions,
  },
  {
    name: "Số lô",
    field: "",
    headerStyle: {
      minWidth: 120,
      maxWidth: 120,
    },
    render: (row: any, index: number, stt: number) => row.consignment || row.item?.consignment,
  },
  {
    name: "HSD",
    field: "",
    headerStyle: {
      minWidth: 120,
      maxWidth: 120,
    },
    cellStyle: {
      textAlign: "center",
    },
    render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row.expiryDate || row.item?.expiryDate),
  },
];
export const ColumnThongTinThuocChoDuyet = [
  {
    name: "STT",
    field: "",
    headerStyle: {
      minWidth: 40,
      maxWidth: 40,
    },
    cellStyle: {
      textAlign: 'center',
    },
    render: (row: any, index: number, stt: number) => stt,
  },
  {
    name: "Mã thuốc/VT",
    field: "",
    headerStyle: {
      minWidth: 150,
      maxWidth: 150,
    },
    render: (row: any, index: number, stt: number) => row.item?.code || row.code,
  },
  {
    name: "Tên thuốc/VT",
    field: "",
    headerStyle: {
      minWidth: 250,
      maxWidth: 250,
    },
    render: (row: any, index: number, stt: number) => row.item?.name || row.itemName,
  },
  {
    name: "Số lượng",
    field: "",
    headerStyle: {
      minWidth: 100,
      maxWidth: 100,
    },
    cellStyle: {
      textAlign: "end",
    },
    render: (row: any, index: number, stt: number) => formatMoney(row.item?.totalQuantity || row.totalQuantity),
  },
  {
    name: "Đơn vị",
    field: "",
    headerStyle: {
      minWidth: 80,
      maxWidth: 80,
    },
    cellStyle: {
      textAlign: "center",
    },
    render: (row: any, index: number, stt: number) => row.item?.unitofMeasureName || row.unitId,
  },
  {
    name: "Thành tiền",
    field: "",
    headerStyle: {
      minWidth: 110,
      maxWidth: 110,
    },
    cellStyle: {
      textAlign: "end",
    },
    render: (row: any, index: number, stt: number) => {
      const price = parseFloat(row?.salePrice || row.item?.salePrice || 0);
      const vat = parseFloat(row?.vat || row.item?.vat || 0);
      const quantity = parseFloat(row.totalQuantity || 0);
      return formatMoney((quantity * price) * (1 + (vat / 100)))
    },
  },
  {
    name: "Cách dùng",
    field: "",
    headerStyle: {
      minWidth: 200,
      maxWidth: 200,
    },

    render: (row: any, index: number, stt: number) => row.usageIns || row.instructions,
  },
  // {
  //   name: "Hoạt chất",
  //   field: "",
  //   headerStyle: {
  //     minWidth: 100,
  //     maxWidth: 100,
  //   },
  //   render: (row: any, index: number, stt: number) => row.item?.actIngName,
  // },
  {
    name: "Số ĐK",
    field: "",
    headerStyle: {
      minWidth: 120,
      maxWidth: 120,
    },
    render: (row: any, index: number, stt: number) => row.regisNum || row.item?.registrationNumber,
  },
  {
    name: "HSD",
    field: "",
    headerStyle: {
      minWidth: 120,
      maxWidth: 120,
    },
    cellStyle: {
      textAlign: "center",
    },
    render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row.expiryDate || row.item?.expiryDate),
  },
];
